import { BooleanColumn, CategoricalColumn, NumericalColumn } from 'baseui/data-table';
import { CustomDateColumn, EMPTY_STRING } from 'commons-ui';

export const COL_NAMES = {
	segmentName: 'segmentName',
	offerName: 'offerName',
	expName: 'expName',
	bucketName: 'bucketName',
	isActive: 'isActive',
	createdAt: 'createdAt',
	updatedAt: 'updatedAt',
	rank: 'rank',
	offer: 'offer',
	code: 'code'
};

export const columnConfigs = [
	CategoricalColumn({
		title: 'Segment Name',
		mapDataToValue: (data: any) => {
			return data[COL_NAMES.segmentName] || EMPTY_STRING;
		},
		maxWidth: 450
	}),
	CategoricalColumn({
		title: 'Offer Name',
		mapDataToValue: (data: any) => {
			return data[COL_NAMES.offerName] || EMPTY_STRING;
		},
		maxWidth: 450
	}),
	CategoricalColumn({
		title: 'Experiment Name',
		mapDataToValue: (data: any) => {
			return data[COL_NAMES.expName] || EMPTY_STRING;
		},
		maxWidth: 450
	}),
	CategoricalColumn({
		title: 'Bucket Name',
		mapDataToValue: (data: any) => {
			return data[COL_NAMES.bucketName] || EMPTY_STRING;
		},
		maxWidth: 450
	}),
	BooleanColumn({
		title: 'isActive',
		mapDataToValue: (data: any) => data[COL_NAMES.isActive],
		maxWidth: 200
	}),
	NumericalColumn({
		title: 'Offer Rank',
		mapDataToValue: (data: any) => data[COL_NAMES.rank],
		maxWidth: 200
	}),
	CategoricalColumn({
		title: 'Cashback Limit(₹)',
		mapDataToValue: (data: any) => data[COL_NAMES.offer].cashbackRewardLimit?.toLocaleString('en-IN'),
		maxWidth: 200
	}),
	CategoricalColumn({
		title: 'Bonus Limit(₹)',
		mapDataToValue: (data: any) => data[COL_NAMES.offer].bonusRewardLimit?.toLocaleString('en-IN'),
		maxWidth: 200
	}),
	NumericalColumn({
		title: 'Applicable transaction count',
		mapDataToValue: (data: any) => data[COL_NAMES.offer].transactionAllowPerDay,
		maxWidth: 200
	}),
	CustomDateColumn({
		title: 'Created At',
		minWidth: 150,
		maxWidth: 200,
		columnName: COL_NAMES.createdAt
	}),
	CustomDateColumn({
		title: 'Updated At',
		minWidth: 150,
		maxWidth: 200,
		columnName: COL_NAMES.updatedAt
	})
];

export const activeFilter = [
	{
		columnKey: 'Is Disabled',
		filterLabel: 'Active Coupons',
		filterValue: false
	}
];
